import { Pipe, PipeTransform } from '@angular/core';
import { applyNwcTerminologyToText } from '../utils/nwc-terminology.util';

/**
 * Applies NWC branding terminology replacements (e.g. "Observation" -> "Transaction")
 * to raw, non-translated strings coming directly from the backend, such as activity
 * log descriptions, for NWC-adapter users only.
 */
@Pipe({
  name: 'nwcTerminology',
})
export class NwcTerminologyPipe implements PipeTransform {
  transform(value?: string): string {
    if (value === undefined || value === null || typeof value !== 'string') {
      return value as unknown as string;
    }

    return this.isCurrentUserNwc() ? applyNwcTerminologyToText(value) : value;
  }

  private isCurrentUserNwc(): boolean {
    try {
      const userData = localStorage.getItem('user-data');
      return userData ? JSON.parse(userData)?.unifier_project_adapter === 'nwc' : false;
    } catch {
      return false;
    }
  }
}
